import React from 'react'; 
import { Link } from 'react-router-dom';
import arrowIcon from './../../../assets/svg/discoverArrow.svg';
import './DiscoverButton.css'

const DiscoverButton = ({url}) => {
  return(
    <div style={{display: 'contents', justifyContent: 'flex-start'}}>
      {url === undefined ? 
      <div className="dButton">
        <p className="discover">Discover</p>
        <img className="discoverArrow" src={arrowIcon} alt="Discover" />
      </div>
      :
      <Link className="dButton" to={url}>
        <p className="discover">Discover</p>
        <img className="discoverArrow" src={arrowIcon} alt="Discover" />
      </Link>}
    </div>
  )
}

export default DiscoverButton;